import _slicedToArray from "/var/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import * as React from "react";
import { isDefined, isNumber, makeUseContext, useEvents } from "../../core/index.js";
var CaptionsContext = React.createContext(null);
export var useCaptions = makeUseContext("useCaptions", "CaptionsContext", CaptionsContext);
export var CaptionsContextProvider = function CaptionsContextProvider(_ref) {
  var children = _ref.children;

  var _useEvents = useEvents(),
      subscribe = _useEvents.subscribe;

  var _React$useState = React.useState(),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      toolbarWidth = _React$useState2[0],
      setToolbarWidth = _React$useState2[1];

  React.useEffect(function () {
    return subscribe("toolbar-width", function (event) {
      if (!isDefined(event) || isNumber(event)) {
        setToolbarWidth(event);
      }
    });
  }, [subscribe]);
  var context = React.useMemo(function () {
    return {
      toolbarWidth: toolbarWidth
    };
  }, [toolbarWidth]);
  return React.createElement(CaptionsContext.Provider, {
    value: context
  }, children);
};